import { RootState } from "../../../../store/store";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { changeNumberValue } from "../../../../store/model";
import { getListNameAndId } from "../../../Editor/shapes/shapeHelper/getSetProperties";
import SelectInput from "./selectInput";

interface LayerSelectProps {
  shapeId: number,
}

const LayerSelect = ({ shapeId }: LayerSelectProps) => {
  const dispatch = useAppDispatch();
  const layerList = useAppSelector((state: RootState) => state.tool.layerList)
  const shapes = useAppSelector((state: RootState) => state.model.present.model.shapes)
  const currentShape = shapes.find((e: GeometricShape) => e.id === shapeId)
  // console.log("layer list", layerList);

  return (
    <div className="property__element">
      <SelectInput
        properyDisplayName="Layer"
        choiseList={getListNameAndId(layerList)}

        setValue={
          function (input): void {
            const payload = {
              id: shapeId,
              propertyValue: input.value,
              propertyName: "layerId",
            }
            console.log(payload, "payload");

            dispatch(changeNumberValue(payload))
          }
        }
        currentValue={{
          label: layerList.find((layer: Layer) => currentShape?.layerId === layer.id)?.name ?? "",
          value: shapeId,
        }}
      />
    </div>
  )
}

export default LayerSelect;